import React from 'react'
import { Paper } from '@material-ui/core'
import './SkyPaper.scss'
var classNames = require('classnames')

export const SkyPaper = ({children, small, className, ...props}) => {
    return <Paper className={classNames({"sky-paper-container": !small}, {"sky-paper-container-small": small}, className)} {...props}>
        {children}
    </Paper>
}